export default __webpack_public_path__ + "static/media/EAST1070.34I-34198_-18443_0.4c3023f9.jpg";